import { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";

import { info } from "./Data";
import logo from "../assets/img/logo.png";
import linkedIn from "../assets/img/nav-icon1.svg";
import github from "../assets/img/nav-icon4.jpg";

export const NavBar = () => {
  const navbarRef = useRef(null);

  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  const toggleButton = navbarRef.current?.querySelector(".navbar-toggler");

  useEffect(() => {
    if (window.innerWidth < 767) {
      setScrolled(true);
    }
    
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else if (window.innerWidth > 767) {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const links = [
    { id: "home", label: "Home", hash: "#home" },
    { id: "skills", label: "Skills", hash: "#skills" },
    { id: "projects", label: "Projects", hash: "#projects" },
  ];

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Navbar expand="md" ref={navbarRef} className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="/" className={"p-sm-3"}>
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {links.map((link) => (
              <Nav.Link
                key={link.id}
                href={link.hash}
                className={
                  activeLink === link.id
                    ? "active navbar-link mt-sm-0 mt-3"
                    : "navbar-link mt-sm-0 mt-2"
                }
                onClick={() => {
                  onUpdateActiveLink(link.id)
                  toggleButton.click();
                }}
              >
                {link.label}
              </Nav.Link>
            ))}
          </Nav>
          <span className="navbar-text my-sm-0 my-3">
            <div className="social-icon" style={{ minWidth: "80px" }}>
              <a href={info.linkedin} target="_blank" rel="noopener noreferrer">
                <img src={linkedIn} alt="" />
              </a>
              <a href={info.github} target="_blank" rel="noopener noreferrer">
                <img src={github} style={{ transform: "scale(1.4)" }} alt="" />
              </a>
            </div>
            <HashLink to="#connect">
              <button className="vvd px-3 py-2 rounded" onClick={()=>toggleButton.click()}>
                <span className="small">Let’s Connect</span>
              </button>
            </HashLink>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
